"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

/**
 * Automatically scrolls to the top of the viewport
 * in response to navigation events.
 * @package
 */
var ScrollToTop = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(ScrollToTop, _Component);

  function ScrollToTop() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ScrollToTop.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var location = this.props.location;

    if (location.pathname !== prevProps.location.pathname) {
      this.scroll();
    }
  };

  _proto.scroll = function scroll() {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  };

  _proto.render = function render() {
    var children = this.props.children;
    return children;
  };

  return ScrollToTop;
}(_react.Component);

var _default = (0, _reactRouterDom.withRouter)(ScrollToTop);

exports["default"] = _default;